<template>
  <b-card>
    <groupe-form/>
  </b-card>
</template>

<script>
import GroupeForm from "@/components/GroupeForm";

export default {
  name: "GroupeAdd",
  components: {GroupeForm}
}
</script>

<style scoped>
</style>
